var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('figure',{staticClass:"sixteen-nine-img"},[_c('img',{attrs:{"src":_vm.imageUrl}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }